import { useSelector } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { RootState } from "../../store/store";
import { createTheme } from "@mui/material/styles";

const ThemeComponent = (props: any) => {
  const { themeMode } = useSelector((state: RootState) => state.themeSlice);

  const theme = createTheme({
    typography: {
      fontFamily: "Plus Jakarta Sans, sans-serif",
      fontSize: 12,
      fontWeightMedium: 600,
    },
    palette:
      themeMode == "dark"
        ? {
            primary: {
              main: "#171b1f",
              800: "#37B8D9",
            },
            secondary: {
              main: "#524f4f", //#7AE4FF
            },
            text: {
              primary: "#4e4e4e",
            },
            // mode: "dark",
          }
        : {
            primary: {
              main: "#123f93",
              800: "#37B8D9",
            },
            secondary: {
              main: "#7AE4FF", //#7AE4FF
            },
            text: {
              primary: "#4e4e4e",
            },
            // mode: "dark",
          },
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            cursor: "pointer",
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          paper: {
            marginTop: "12px !important", // Adjust spacing between TextField and option list
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15) !important",
            borderRadius: "3px",
          },
          option: {
            padding: "10px !important",
            paddingLeft: "20px !important",
            fontSize: "14px",
            "&:hover": {
              backgroundColor: "#d0d4da !important",
            },
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            borderRadius: "0px !important",
            background: "#ffffff",
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            minHeight: "48px !important",
            paddingLeft: "0px !important",
          },
        },
      },
      MuiPopover:{
        styleOverrides: {
          root: {
            marginTop: "10px",
          },
          paper:{
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15) !important",
          }
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            // borderRadius: "16px",
            boxShadow: "none !important",
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            zIndex: "99",
            position: "relative",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            top: ownerState.shrink ? "-3px" : "-7px",
            transition: "top 0.2s ease-in-out", // Smooth transition when shrinking
          }),
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            borderRadius: "4px !important",
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: "0.79rem",
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            borderRadius: "4px !important",
          },
          input: {
            padding: "8px 14px !important",
            fontSize: 12,
            margin: "2px"
            // minWidth:"240px",
          },
          inputMultiline: {
            padding: "12px !important",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: ({ ownerState }: any) => {
            const { variant, color } = ownerState;
            return {
              borderRadius: 8,
              // height:35,
              fontSize:12,
              fontWeight:500,
              textTransform: "capitalize",
              ...(variant === "contained" && {
                backgroundColor:
                  color === "error"
                    ? "#d32f2f"
                    : color === "warning"
                    ? "#ffa726"
                    : color === "success"
                    ? "#2e7d32"
                    : color === "info"
                    ? "#0288d1"
                    : "#123f93", // default contained color
                color: "#fff",
                "&:hover": {
                  backgroundColor:
                    color === "error"
                      ? "#b71c1c"
                      : color === "warning"
                      ? "#fb8c00"
                      : color === "success"
                      ? "#1b5e20"
                      : color === "info"
                      ? "#0277bd"
                      : "#3C6ED0", // default hover for contained
                },
              }),
              ...(variant === "outlined" && {
                borderColor:
                  color === "error"
                    ? "#d32f2f"
                    : color === "warning"
                    ? "#ffa726"
                    : color === "success"
                    ? "#2e7d32"
                    : color === "info"
                    ? "#0288d1"
                    : "#3C6ED0", // default outlined color
                color:
                  color === "error"
                    ? "#d32f2f"
                    : color === "warning"
                    ? "#ffa726"
                    : color === "success"
                    ? "#2e7d32"
                    : color === "info"
                    ? "#0288d1"
                    : "#3C6ED0",
                "&:hover": {
                  borderColor:
                    color === "error"
                      ? "#b71c1c"
                      : color === "warning"
                      ? "#fb8c00"
                      : color === "success"
                      ? "#1b5e20"
                      : color === "info"
                      ? "#0277bd"
                      : "#1565c0", // default hover for outlined
                  color:
                    color === "error"
                      ? "#b71c1c"
                      : color === "warning"
                      ? "#fb8c00"
                      : color === "success"
                      ? "#1b5e20"
                      : color === "info"
                      ? "#0277bd"
                      : "#1565c0",
                },
              }),
              ...(variant === "text" && {
                color:
                  color === "error"
                    ? "#d32f2f"
                    : color === "warning"
                    ? "#ffa726"
                    : color === "success"
                    ? "#2e7d32"
                    : color === "info"
                    ? "#0288d1"
                    : "#3C6ED0", // default text color
                "&:hover": {
                  backgroundColor:
                    color === "error"
                      ? "rgba(211, 47, 47, 0.1)"
                      : color === "warning"
                      ? "rgba(255, 167, 38, 0.1)"
                      : color === "success"
                      ? "rgba(46, 125, 50, 0.1)"
                      : color === "info"
                      ? "rgba(2, 136, 209, 0.1)"
                      : "rgba(25, 118, 210, 0.1)", // default hover for text
                },
              }),
            };
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            marginBottom: "24px",
          },
        },
      },
      MuiDialogContentText: {
        styleOverrides: {
          root: {
            color: themeMode == "dark" ? "white" : "",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: "none",
            padding: "6px 12px",
            border: "1px solid #dcdce1",
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            "&:nth-of-type(even)": {
              backgroundColor: "#efefef",
            },
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          toolButton: {
            fontWeight: 600,
          },
          data: {
            fontWeight: 600,
          }
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: "4px 16px",
            left: "auto !important",
          },
          footer: {
            border: "none",
          },
          head: {
            padding: "4px 16px",
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            padding: "0px !important",
            fontSize: 12
          },
          // notchedOutline: {
          //   "& legend": {
          //     display: "none", // Correct way to hide the legend
          //   },
          // },
        },
      },
      MUIDataTableBodyCell:{
        styleOverrides: {
          root: {
            fontSize: 12,
            fontWeight: 400,
          },
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: {
            minHeight: "45px !important",
          },
          content: {
            margin: "0px !important",
          },
        },
      },
    },
  });
  
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};
export default ThemeComponent;
